import { Pipe, PipeTransform } from '@angular/core'; 
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/ar';

dayjs.extend(relativeTime);

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {

   transform(value: string | Date, lang: 'fr' | 'en' | 'ar' = 'fr'): string {
    return dayjs(value).locale(lang).fromNow();
  }

}
